import React, {Component} from 'react';
import { Link } from 'components/ReactRouterDomLocalized';
import MasonryLayout from 'react-masonry-layout';
import isMobile from 'ismobilejs';

import ModalAddGuestbookMessage from '../../components/modals/ModalAddGuestbookMessage';
import GuestbookItem from '../../components/guestbook/GuestbookItem';

import {t} from 'l10n'

import paths from 'paths';

import 'sass/profile/guestbookProfile.scss';

class ProfileGuestbookBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.guestbookMessages.totalCount != this.props.guestbookMessages.totalCount) {
            if(this.masonryLayout.instanceElement) {
                this.masonryLayout.getBricksInstance().pack();
            }
        }
    }

    render() {
        let {guestbookMessages, currentUser, returnPath, user, blacklistedMe, sectionNumber, match} = this.props,
            {list, totalCount} = guestbookMessages;

        let {showModal} = this.state;

        const sizes = [
            { mq: '320px', columns: 1, gutter: 10 },
            { mq: '360px', columns: 1, gutter: 10 },
            { mq: '680px', columns: 2, gutter: 10 },
            { mq: '720px', columns: 2, gutter: 20 },
            { mq: '1060px', columns: 3, gutter: 20 },
            { mq: '1420px', columns: 4, gutter: 25 },
            { mq: '1560px', columns: 4, gutter: 30 },
            { mq: '1601px', columns: 4, gutter: 40 },
        ];

        return (
            <aside className={'guestbook-main ' + ((sectionNumber % 2)==0?'even':'odd')}>
                <ModalAddGuestbookMessage
                    show={showModal}
                    closeFn={() => this.setState({showModal: false})}
                    currentUser={currentUser}
                    user={user}
                    blacklistedMe={blacklistedMe}
                    returnPath={returnPath}
                />

                <div className="content">
                    <div className="heading">
                        <h2>{t('Guestbook')} <em>{totalCount}</em></h2>
                        <div>
                            {(list.length && !isMobile.any) ? <Link to={paths.profileGuestbook.toPath({nick: match.params.nick})} className="list-items">{t('See all guestbook')}</Link> : null}
                            <a className="add-item" onClick={() => this.setState({showModal: true})}>{t('Add a comment')}</a>
                        </div>
                    </div>
                    <div className="list-guestbook-main">
                        <MasonryLayout
                            sizes={sizes}
                            id="list-guestbook"
                            infiniteScroll={() => {}}
                            ref={(instance) => this.masonryLayout = instance}
                        >
                            {list.map((item) => <GuestbookItem key={item.id} guestbookMessage={item} />)}
                        </MasonryLayout>
                    </div>
                    {(list.length && isMobile.any) ? <Link to={paths.profileGuestbook.toPath({nick: match.params.nick})} className="get-all-guestbook">{t('See all guestbook')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default ProfileGuestbookBlock;


// WEBPACK FOOTER //
// ./src/components/profile/ProfileGuestbookBlock.js